<template>
    <div class="main" :style="{ backgroundImage: `url(${bgImageUrl})` }">

        <img src="../../../assets/images/set.png" style="position: absolute;top: 20px;right: 20px;z-index: 30;
        width: 100px;height: 50px;" @click="venueDrawer = true" alt="">
        <div class="mask" v-if="showMask&&project" :style="{ opacity: maskOpacity}"></div>
        <div class="content">
            <div class="match-title-div ">
                <div class="match-title" v-if="match">
                    {{ match.MatchName }}
                </div>
            </div>

            <div class="detail">
                <div class="project" v-if="project">
                    {{ project.GroupName + project.GenderRuleText + project.ProjectName }}
                </div>
                <div class="table-div">
                    <div class="table-head-div">
                        <div class="table-head-item" style="width: 15%;">
                            <span>名次</span>
                        </div>
                        <div class="table-head-item" style="width: 30%;">
                            <span>运动员</span>
                        </div>
                        <div class="table-head-item" style="width: 25%;">
                            <span>单位/院校</span>
                        </div>
                        <div class="table-head-item" style="width: 15%;">
                            <span>成绩</span>
                        </div>
                        <div class="table-head-item" style="width: 15%;">
                            <span>得分</span>
                        </div>
                    </div>
                    <div class="table-body-div" ref="scrollContainer" @mouseenter="pauseScroll"
                        @mouseleave="resumeScroll">
                        <div class="row-content-div" v-for="user in project.ContestantUser">
                            <div class="row-cell row-rank-cell"
                                :class="user.Ranking >= 1 && user.Ranking <= 3 ? 'top-three-cell' : ''"
                                style="width: 15%;">
                                <img v-if="user.Ranking == 1" class="top-img" src="../../../assets/images/top1-1.png" />
                                <img v-if="user.Ranking == 2" class="top-img" src="../../../assets/images/top2-1.png" />
                                <img v-if="user.Ranking == 3" class="top-img" src="../../../assets/images/top3-1.png" />
                                <span v-if="user.Ranking > 3">{{ user.Ranking }}</span>
                            </div>
                            <div class="row-cell"
                                :class="user.Ranking >= 1 && user.Ranking <= 3 ? 'top-three-cell' : ''"
                                style="width: 30%;"> {{
                                    user.UserName }}
                            </div>
                            <div class="row-cell"
                                :class="user.Ranking >= 1 && user.Ranking <= 3 ? 'top-three-cell' : ''"
                                style="width: 25%;"> {{
                                    user.Unit }}</div>
                            <div class="row-cell"
                                :class="user.Ranking >= 1 && user.Ranking <= 3 ? 'top-three-cell' : ''"
                                style="width: 15%;"> {{
                                    user.Score }}</div>
                            <div class="row-cell"
                                :class="user.Ranking >= 1 && user.Ranking <= 3 ? 'top-three-cell' : ''"
                                style="width: 15%;"> {{
                                    user.TotalPoints }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-drawer :visible.sync="venueDrawer" :modal="false">
            <div style="padding: 30px;">
                <el-form>
                    <el-form-item label="自动切换项目">
                        <el-switch v-model="editIsAutoNextPro" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="轮询次数">
                        <el-input-number size="mini" v-model="editScrollCount" :min="1" :max="10"></el-input-number>
                    </el-form-item>
                    <el-form-item label="显示蒙层">
                        <el-switch v-model="editShowMask" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="蒙层透明度">
                        <el-input-number size="mini" v-model="editMaskOpacity" :min="0" :max="1"
                            :step="0.1"></el-input-number>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="saveSettings">确定</el-button>
                    </el-form-item>
                </el-form>
                <el-collapse v-model="activeNames">
                    <el-collapse-item v-for="(item, index) in matchWholeSchedule" :name="item.VenueId">
                        <template slot="title">
                            {{ item.VenueName }}
                        </template>
                        <div class="project-item" v-for="(pro, subIndex) in item.Projects"
                            @click="chooseProject(pro, index, subIndex)">{{
                                pro.GroupName + pro.GenderRuleText +
                                pro.ProjectName }}
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </el-drawer>
    </div>

</template>

<script>
import MatchService from '@/request-server/request-services/match-services.js';
import SystemService from '@/request-server/request-services/system-services.js';
import BrowserStorage from '@/utils/utils-browser-storage.js';
import Common from '@/utils/utils-common.js';
import Url from '../../../request-server/request-url';
export default {
    data() {
        return {
            routerMatchId: '',
            match: null,
            project: { ProjectName: '', GroupName: '', GenderRuleText: '' },
            matchWholeSchedule: [],
            activeNames: [],
            indexMark: [],
            currIndex: -1,
            currVenueIndex: 0,
            currProIndex: 0,
            venueDrawer: false,
            scrollInterval: null,
            isPaused: false,
            scrollSpeed: 50, // 滚动间隔时间（毫秒）
            scrollStep: 2,    // 每次滚动步长（像素）
            isAutoNextPro: true,
            scrollCount: 2,
            showMask: true,
            maskOpacity: 0.5,
            editIsAutoNextPro: true,
            editScrollCount: 2,
            editShowMask: true,
            editMaskOpacity: 0.5,

            currScrollCount: 1,
            bgImageUrl: require('@/assets/images/screen-mirroring-bg.png'),
            fileRootPath: Url.getDownloadBaseUrl() + 'uploadfiles/',

        }
    },
    mounted() {
        //  this.addResizeObserver();
    },
    beforeDestroy() {
        this.cleanup();
    },
    created() {
        this.initData();
        setInterval(() => {
            this.refreshMatchWholeSchedule();
        }, 5000);
    let value = BrowserStorage.getItem('matchRankEditIsAutoNextPro');
    if (value != null) {
        this.isAutoNextPro = value ? value == 'true' : true;;
        this.editIsAutoNextPro = value ? value == 'true' : true;;
    }
    value = BrowserStorage.getItem('matchRankEditScrollCount');
    if (value != null) {
        this.scrollCount = value;
        this.editScrollCount = value;
    }
    value = BrowserStorage.getItem('matchRankEditShowMask');
    console.log(value)
    if (value != null) {
        this.showMask = value ? value == 'true' : true;;
        this.editShowMask = value ? value == 'true' : true;;
    }
    value = BrowserStorage.getItem('matchRankEditMaskOpacity');
    if (value != null) {
        this.maskOpacity = value;
        this.editMaskOpacity = value;
    }





    },
    methods: {
        saveSettings(){
            BrowserStorage.setItem('matchRankEditIsAutoNextPro', this.editIsAutoNextPro);
            BrowserStorage.setItem('matchRankEditScrollCount', this.editScrollCount);
            BrowserStorage.setItem('matchRankEditShowMask', this.editShowMask);
            BrowserStorage.setItem('matchRankEditMaskOpacity', this.editMaskOpacity);

            this.isAutoNextPro = this.editIsAutoNextPro;
            this.scrollCount = this.editScrollCount;
            this.showMask = this.editShowMask;
            this.maskOpacity = this.editMaskOpacity;

            this.venueDrawer = false;
        },
        checkScrollNeeded() {
            const container = this.$refs.scrollContainer;
            if (!container) return;

            const needsScroll = container.scrollHeight > container.clientHeight;
            if (needsScroll) {
                this.stopScroll();
                this.startScroll();
            } else {
                this.stopScroll();
                setTimeout(() => {
                    this.nextPro();
                }, this.currScrollCount * 30000);
            }
        },


        startScroll() {
            this.scrollInterval = setInterval(() => {
                if (!this.isPaused) {
                    const container = this.$refs.scrollContainer;
                    const isBottom = container.scrollTop + container.clientHeight >= container.scrollHeight;
                    if (isBottom) {
                        console.log(this.isAutoNextPro, this.indexMark.length, this.currScrollCount, this.scrollCount)
                        if (this.isAutoNextPro == false || this.indexMark.length <= 1 || this.currScrollCount < this.scrollCount) {
                            console.log('currScrollCount', this.currScrollCount)
                            this.stopScroll();
                            setTimeout(() => {
                                container.scrollTop = 0;
                                this.currScrollCount++;
                                setTimeout(() => {
                                    this.startScroll();
                                }, 3000);
                            }, 3000);
                        } else {
                            console.log('下一个项目')
                            this.currScrollCount = 1;
                            clearInterval(this.scrollInterval);
                            setTimeout(() => {
                                container.scrollTop = 0;
                                this.nextPro();
                            }, 3000);

                        }

                    } else {
                        container.scrollTop += this.scrollStep;
                    }
                }
            }, this.scrollSpeed);
        },

        stopScroll() {
            clearInterval(this.scrollInterval);
            this.scrollInterval = null;
        },

        pauseScroll() {
            this.isPaused = true;
        },

        resumeScroll() {
            this.isPaused = false;
        },

        cleanup() {
            this.stopScroll();
            if (this.observer) {
                this.observer.disconnect();
            }
        },
        // addResizeObserver() {
        //     this.observer = new ResizeObserver(() => this.checkScrollNeeded());
        //     this.observer.observe(this.$refs.scrollContainer);
        // },
        refreshMatchWholeSchedule() {
            let id = this.$route.params.id;
            this.routeMatchId = id;
            this.matchWholeSchedule = [];
            MatchService.getMatchWholeSchedule({ matchId: this.routeMatchId }).then(res => {
                if (res.code == 0) {
                    this.indexMark = [];
                    res.data.forEach((venue, index) => {
                        let v = {
                            VenueName: venue.VenueName,
                            VenueId: venue.VenueId,
                            Projects: []
                        }
                        let idx = 0;
                        venue.MatchVenueProject.forEach((pro) => {
                            if (pro.Project.IsDisclosure == 1) {
                                let project = {
                                    GroupName: pro.Project.GroupName,
                                    GenderRuleText: pro.Project.GenderRuleText,
                                    ProjectName: pro.Project.ProjectName,
                                    ProjectId: pro.Project.ProjectId,
                                    Regions: [],
                                    ContestantUser: []
                                }

                                if (pro.Project.IsSetRanking) {
                                    let users = [];
                                    pro.Project.Regions.forEach(region => {
                                        region.ContestantUserGroups.forEach(group => {
                                            users = [...users, ...group.ContestantUsers]
                                        });
                                    });
                                    let newUsers = users.filter(a => a.Ranking > 0).sort((a, b) => a.Ranking - b.Ranking);
                                    newUsers = [...newUsers, ...users.filter(a => a.Ranking == 0).sort((a, b) => a.TotalPoints - b.TotalPoints)]
                                    project.ContestantUser = newUsers;
                                }
                                if (project.ContestantUser.length > 0) {
                                    v.Projects.push(project);
                                    this.indexMark.push(index + '-' + idx);
                                    idx++;
                                }
                            }
                        });

                        this.matchWholeSchedule.push(v)
                        this.activeNames.push(v.VenueId);
                        v = null;
                    })
                    res = null;
                };
            });
        },
        initData() {
            let id = this.$route.params.id;
            if (id) {
                this.routeMatchId = id;
                this.matchWholeSchedule = [];
                MatchService.getMatchWholeSchedule({ matchId: this.routeMatchId }).then(res => {
                    if (res.code == 0) {
                        this.indexMark = [];
                        res.data.forEach((venue, index) => {
                            let v = {
                                VenueName: venue.VenueName,
                                VenueId: venue.VenueId,
                                Projects: []
                            }
                            let idx = 0;
                            venue.MatchVenueProject.forEach((pro) => {
                                if (pro.Project.IsDisclosure == 1) {
                                    let project = {
                                        GroupName: pro.Project.GroupName,
                                        GenderRuleText: pro.Project.GenderRuleText,
                                        ProjectName: pro.Project.ProjectName,
                                        ProjectId: pro.Project.ProjectId,
                                        Regions: [],
                                        ContestantUser: []
                                    }

                                    if (pro.Project.IsSetRanking) {
                                        let users = [];
                                        pro.Project.Regions.forEach(region => {
                                            region.ContestantUserGroups.forEach(group => {
                                                users = [...users, ...group.ContestantUsers]
                                            });
                                        });
                                        let newUsers = users.filter(a => a.Ranking > 0).sort((a, b) => a.Ranking - b.Ranking);
                                        newUsers = [...newUsers, ...users.filter(a => a.Ranking == 0).sort((a, b) => b.Score - a.Score)]
                                        project.ContestantUser = newUsers;
                                    }
                                    if (project.ContestantUser.length > 0) {
                                        v.Projects.push(project);
                                        this.indexMark.push(index + '-' + idx);
                                        idx++;
                                    }
                                }
                            });

                            this.matchWholeSchedule.push(v)
                            this.activeNames.push(v.VenueId);
                            v = null;
                        })
                        res = null;
                        console.log(this.matchWholeSchedule)
                    };

                    if (this.indexMark.length > 0) {
                        //初始化第一个项目
                        let indexs = this.indexMark[0].split('-');
                        this.project = this.matchWholeSchedule[indexs[0]].Projects[indexs[1]];
                        this.currIndex = 0;
                        setTimeout(() => {
                            this.checkScrollNeeded();
                        }, 1500);
                    }
                });

                if (this.match == null) {
                    MatchService.getMatchDetail({ matchId: this.routeMatchId }).then(res => {
                        if (res.code == 0) {
                            this.match = res.data;
                            if (this.match.RankLargeScreenBackGroundImageFile) {
                                this.bgImageUrl = this.fileRootPath + this.match.RankLargeScreenBackGroundImageFilePath;
                            }

                        }
                    })
                }
            } else {
                window.close();
            }
        },
        chooseProject(pro, index, subIndex) {
            this.currIndex = this.indexMark.indexOf(index + '-' + subIndex);
            if (pro == null) {
                this.project = this.matchWholeSchedule[index].Projects[subIndex];
            } else {
                this.project = pro;
            }

            this.stopScroll();
            this.currScrollCount = 1;
            setTimeout(() => {
                this.checkScrollNeeded();
            }, 1500);
        },
        nextPro() {
            if (this.currIndex < this.indexMark.length - 1) {
                //下一个
                this.currIndex++;
                let indexs = this.indexMark[this.currIndex].split('-');
                this.chooseProject(null, indexs[0], indexs[1]);
            } else {
                //第一个
                this.currIndex = 0;
                let indexs = this.indexMark[this.currIndex].split('-');
                this.chooseProject(null, indexs[0], indexs[1]);
            }

        }
    }
}
</script>

<style lang="scss">
.main {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url('../../../assets/images/screen-mirroring-bg.png') no-repeat center center fixed;
    background-size: 100% 100%;
    overflow: hidden;
    overflow-y: auto;
    z-index: 1;

    .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0);
        z-index: 2;

    }

    .content {
         position: absolute;
        width: 100%;
        height: 100%;
        z-index: 3;
        .match-title-div {
            position: relative;
            display: flex;
            height: 90px;
            // text-align: center;
            align-items: center;
            /* 垂直居中 */
            // margin: 0 auto 0;
            margin-left: 2%;
            // width: 1000px;

            .match-title {
                position: relative;
                width: 100%;
                font-size: 45px;
                color: #fff;
                font-family: 'PangMenChenDao', sans-serif;
            }
        }


        .detail {
            .project {
                margin: 100px 0 20px;
                text-align: center;
                height: 50px;
                line-height: 50px;
                font-size: 30px;
                color: #fff;
                font-family: '黑体';
            }

            .table-div {
                width: 80%;
                margin: 0 auto;
                padding-bottom: 30px;
                box-sizing: border-box;

                .table-head-div {
                    width: 100%;
                    height: 50px;
                    background: url('../../../assets/images/table-head.png') no-repeat center center fixed;
                    background-size: 100% 100%;
                    display: flex;
                    margin: 0 auto;
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                    font-family: 'OPPOSans B';

                    .table-head-item {
                        width: 20%;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        color: #fff;
                        font-size: 25px;
                    }
                }

                .table-body-div {
                    position: relative;
                    width: 100%;
                    max-height: 600px;
                    background-size: 100% 100%;
                    font-family: 'OPPOSans M';
                    overflow: hidden;
                    overflow-y: auto;
                    scrollbar-width: none;
                    /* Firefox */
                    -ms-overflow-style: none;
                    /* IE/Edge */
                    transition: all 0.1s;

                    .row-content-div {
                        position: relative;
                        width: 100%;
                        min-height: 50px;
                        text-align: center;
                        font-size: 22px;
                        display: flex;
                        background-color: rgba(131, 133, 247, 0.8);

                        .row-cell {
                            color: #fff;
                            line-height: 35px;
                            padding: 5px 0;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: center;
                            /* 水平居中 */
                            align-items: center;
                            /* 垂直居中 */
                            width: 100vw;

                            /* 容器宽度为视口宽度 */
                            .top-img {
                                width: 50px;
                                height: 30px;
                            }
                        }

                        .row-rank-cell {
                            display: flex;
                            justify-content: center;
                            /* 水平居中 */
                            align-items: center;
                            /* 垂直居中 */
                            width: 100vw;
                            /* 容器宽度为视口宽度 */
                        }

                        .top-three-cell {
                            color: #F30F8C !important;
                            font-family: 'OPPOSans B';
                            ;
                        }
                    }


                    .row-content-div:nth-child(odd) {
                        background-color: rgb(255, 255, 255, 0.4) !important;
                    }
                }
            }
        }
    }
}



.el-collapse-item__header {
    color: #000;
    font-size: 20px;
    font-family: 'OPPOSans B';
}

.project-item {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    font-size: 16px;
    cursor: pointer;
    font-family: 'OPPOSans M';
}
</style>
